import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromUser from '../reducers/user.reducer';

export const selectUserState = createFeatureSelector<fromUser.UserState>('user');

export const selectImpersonatedUserId = createSelector(
  selectUserState,
  (state: fromUser.UserState) => {
    console.log('state', JSON.stringify(state));
    return state.impersonatedUserId;
  }
);



// WEBPACK FOOTER //
// ./src/app/store/selectors/user.selectors.ts